export default __webpack_public_path__ + "static/media/MyPage_Player.7f16f005.svg";